import { environment } from '../../environments/environment';
import { Subscription } from 'rxjs';
import { Component, OnInit, AfterViewInit, HostListener, EventEmitter, ErrorHandler, ViewChild, ViewChildren, QueryList, ElementRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { AdvancedSearchData } from './search.model';
import { SearchService } from './search.service';
import { ClearanceItem, ListSearchData, CIImage, MassUpdateData, CITag, CIAsset, CIDocument } from '../clearance-item/clearance-item.model';
import { FormBuilder, FormGroup, FormControl, FormArray, FormControlName, Validators } from '@angular/forms';
import { PlatformLocation } from '@angular/common';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { MessageBrokerService } from '../shared/core/message-broker.service';
import { ProjectItem } from '../project/projectItem';
import { AppService } from '../app.service';
import { ILookup, LookupList } from '../shared/lookup';
import { Location } from '@angular/common';
import { SharedUtils, DateUtils } from '../shared/utils';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { AuthService } from '../shared/core/index';
import { ClearanceItemBulkComponent } from '../clearance-item/bulk-action/clearance-item-bulk.component';
import { NotificationsService, Notification } from '../shared/helper-components/index'

import { ClearanceItemService } from '../clearance-item';
import { ReportsService } from '../reports/reports.service';
import { ReportBuilder } from '../reports/reports-builder.model';
import { NavigationTrackerService } from '../shared/helper-components/navigation-tracker.service';

@Component({
    selector: 'search',
    standalone: false,
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, AfterViewInit {

    @ViewChild('maincontainer', { static: false }) public maincontainer: ElementRef;
    @ViewChild('bulkAction', { static: false }) bulkActionComponent: ClearanceItemBulkComponent;
    /** Filter mat-selects (Status/Tags/etc.); used to unblock Apply while a panel is open (TR-005). */
    @ViewChildren(MatSelect) filterSelects: QueryList<MatSelect>;

    isClearanceUser: boolean = false;
    itemList: ClearanceItem[] = [];
    itemSelectedList: ClearanceItem[] = [];
    searchForm: FormGroup;
    showSpinner: boolean = false;
    listSearchData: AdvancedSearchData = new AdvancedSearchData();
    openedProject: ProjectItem;
    statusLookup: ILookup[] = [];
    tagsLookup: ILookup[] = [];
    statusLookupBulk: ILookup[] = [];
    tagsLookupBulk: ILookup[] = [];
    isLoadingRecord: boolean = false;
    isLoadingMoreRecords: boolean = false;
    inErrorState: boolean = false;
    defaultMessage: string = 'Enter criteria and hit \'Apply\' to search';
    noRecordsFoundMessage: string = 'No items found with the provided filters.';
    searchMessage: string = '';
    showMobileFilters: boolean = false;
    bulkDataList: Array<Object> = new Array<Object>();
    massUpdateData: MassUpdateData = new MassUpdateData();
    modalstatusLookup: ILookup[] = [];
    searchProjectId: string = null;
    selectedItem: ClearanceItem = new ClearanceItem();
    showOtherTitlesModal: boolean = false;
    sortByLookup: ILookup[] =
        [{ id: "CreatedDate", name: 'Date Added', type: "" },
        { id: "Name", name: 'A-Z', type: "" },
        { id: "LastModifiedDate", name: 'Date Modified', type: "" },
        { id: "Deadline__c", name: 'Deadline', type: "" }];

    statusMultiSelect = { allOptionChecked: true, formControl: null };
    tagsMultiSelect = { allOptionChecked: true, formControl: null };
    /** Snapshot previo al último cambio del usuario (mat-select puede emitir All mezclado con otras en un solo evento). */
    private lastStatusSelectionForFilter: string[] = ['All'];
    private lastTagsSelectionForFilter: string[] = ['All'];
    formValuesRetrievedFromLocalStorage: boolean = false;
    reportGenerateParams : ReportBuilder;

    currentPage: number = 1;
    pageSize: number = 20;
    totalItems: number;

    ngAfterViewInit(): void {
        SharedUtils.RemoveTooltipIfNeeded('#more_titles_tooltip');

        if (SharedUtils.IsMobile()) {

            this.openFirst();
            setTimeout(() => {
                this.closeFirst();
            }, 1500);
        }
        SharedUtils.FixFlickering();
        this.wireFilterSelectBackdropFix();
        if (this.filterSelects) {
            this.filterSelects.changes.subscribe(() => this.wireFilterSelectBackdropFix());
        }
    }

    /** Allow clicks through transparent select backdrops so Apply/Clear remain reachable (TR-005). */
    private _selectBackdropSubscribed = new WeakSet<MatSelect>();
    private wireFilterSelectBackdropFix(): void {
        if (!this.filterSelects) {
            return;
        }
        this.filterSelects.forEach(select => {
            if (!select || this._selectBackdropSubscribed.has(select)) {
                return;
            }
            this._selectBackdropSubscribed.add(select);
            select.openedChange.subscribe(open => {
                if (!open) {
                    return;
                }
                // Next frame: Material has attached the backdrop.
                setTimeout(() => {
                    document.querySelectorAll('.cdk-overlay-backdrop.cdk-overlay-backdrop-showing').forEach(node => {
                        (node as HTMLElement).style.pointerEvents = 'none';
                    });
                }, 0);
            });
        });
    }

    /**
     * Close open filter selects on outside pointerdown so panels don't stick after
     * backdrop pointer-events are disabled (TR-005).
     */
    @HostListener('document:pointerdown', ['$event'])
    onDocumentPointerDown(event: PointerEvent): void {
        if (!this.filterSelects || !this.filterSelects.some(s => s.panelOpen)) {
            return;
        }
        const target = event.target as HTMLElement | null;
        if (target && target.closest('.mat-mdc-select-panel, .mat-select-panel')) {
            return;
        }
        // Close; if the target is Apply/Clear the subsequent click handler runs normally.
        this.closeOpenFilterSelects();
    }

    setStatusClasses(item) {
        var classes = 
        { 
            'not-clear': item.status == 'NOT CLEAR' || item.status == 'DENIED',
            'clear': (item.status && item.status.includes('CLEAR') && item.status != 'NOT CLEAR' && item.status != 'PERMISSIBLE - Graphics Require Review') || item.status=='PERMISSIBLE' || item.status == 'PERMISSIBLE - Background Use Only' || item.status == 'APPROVED',
            'new': item.status == 'NEW',
            'abandoned': item.status == 'ABANDONED',
            'pending': item.status && item.status == 'PERMISSIBLE - Graphics Require Review' || item.status.includes('PENDING') || item.status == 'DEFERRED'
        };
        return classes;
    }
       openFirst() {
        this.showMobileFilters = true;
    }

    closeFirst() {
        this.showMobileFilters = false;
    }

    ngOnInit(): void {
        this.formValuesRetrievedFromLocalStorage = false;
        this.isClearanceUser = this._authService.isUserInRole(environment.clearanceRole);// || !environment.production;

        this.searchForm = this.fb.group({
            keyword: '',
            currentProject: true,
            projectId: '',
            sortBy: this.sortByLookup[0].id,
            sortOrder: 'DESC',
            status: [['All']],
            projectName: '',
            tags: [['All']],
            copyright: '',
            author: '',
            episode: '',
            season: '',
            reportGroup: '',
            deadline: null,
            createdDate: null,
            pageSize: [20],
            pageStartIndex: 0,
            totalNumberOfRecords: 0
        });
        this.tagsMultiSelect.formControl = this.searchForm.controls.tags;
        this.statusMultiSelect.formControl = this.searchForm.controls.status;
        this.syncMultiselectSnapshotsFromForm();
        this.searchForm.controls.currentProject.valueChanges.subscribe(p => {
            this.searchProjectId = p ? this.searchForm.controls.projectId.value : null;
            if (this.formValuesRetrievedFromLocalStorage)
                this.loadCILookups();
        });

        this.searchForm.valueChanges.subscribe(f => {

        });


        let s = JSON.parse(localStorage.getItem('AdvancedSearchData'));

        if (s) {
            this.searchForm.patchValue({
                keyword: s.keyword,
                currentProject: this.isClearanceUser ? s.currentProject : true,
                projectId: s.projectId,
                // sortBy:string;
                //sortOrder:string;
                status: s.status,
                projectName: s.projectName,
                tags: s.tags,
                copyright: s.copyright,
                author: s.author,
                episode: s.episode,
                season: s.season,
                reportGroup: s.reportGroup,
                deadline: DateUtils.toFormDate(s.deadline),
                createdDate: DateUtils.toFormDate(s.createdDate),
                pageSize: s.pageSize,
                pageStartIndex: s.pageStartIndex,
                totalNumberOfRecords: s.totalNumberOfRecords
            });

            this.searchForm.markAsDirty();
            this.syncMultiselectSnapshotsFromForm();

            this.searchItems();
        }
        this.formValuesRetrievedFromLocalStorage = true;
        console.log('calling this.subScribeProjectNameChanges()');
        this.subScribeProjectNameChanges();
    }

    private routeScrollPositions: { [url: string]: number }[] = [];
    private subscriptions: Subscription[] = [];
    private wasPop: boolean = false;
    private previousNavigationUrl: string;


    constructor(
        private _searchService: SearchService,
        private fb: FormBuilder,
        private _route: ActivatedRoute,
        public _authService: AuthService,
        private _router: Router,
        private _messageBrokerService: MessageBrokerService,
        private _appService: AppService,
        private _location: Location,
        private _errorHandler: GlobalErrorHandler,
        private _notificationsService: NotificationsService,
        platLocation: PlatformLocation,
        private _clearanceItemService: ClearanceItemService,
        private _reportService: ReportsService,
        private navigationTracker: NavigationTrackerService,
        private cd: ChangeDetectorRef,
        private ngZone: NgZone
    ) {
        this.searchMessage = this.defaultMessage;
        this.setupAutoScrolling(platLocation);
        this.subscribeToChanges();
    }

    subscribeToChanges() {

        this._messageBrokerService.subscribeToItemChanged().subscribe(i => {
            this.getClearanceItem(i.id);
        });

        this._messageBrokerService.subscribeToItemDeleted().subscribe(id => {
            let index = this.itemList.findIndex(i => i.id == id);
            if (index >= 0) {
                this.itemList.splice(index, 1);
            }
        });
    }

    setupAutoScrolling(platLocation: PlatformLocation) {

        platLocation.onPopState(() => {
            this.wasPop = true;
        });

        let self = this;

        this.subscriptions.push(
            self._router.events.subscribe((e) => {

                if ((e instanceof NavigationStart) && self.selectedItemId) {

                    if (!self.isLinkActive('/search'))
                        return;

                    let index = self.previousNavigationUrl !== null ? self.previousNavigationUrl : e.url;
                    self.routeScrollPositions[index] = window.pageYOffset;
                } else if (e instanceof NavigationEnd) {
                    if (!self._router.isActive('search', false)) {
                        window.scrollTo(0, 0);
                        self.wasPop = false;
                        return;
                    }

                    self.previousNavigationUrl = e.url;
                    if (self.wasPop) {
                        if (!self.routeScrollPositions[e.url]) {
                            window.scrollTo(0, 0);
                            self.wasPop = false;
                            return;
                        }
                        setTimeout(() => {
                            window.scrollTo(0, self.routeScrollPositions[e.url] || 0);
                            // self._notificationsService.add(new Notification('info', 'window scroll for :\'' + e.url + '\' to:' + self.routeScrollPositions[e.url]));
                        }, 1000);
                        self.wasPop = false;

                    } else {
                        window.scrollTo(0, 0);
                    }
                };
            })
        );
    }

    public isLinkActive(url) {
        let charPos = this._router.url.indexOf('?');
        let cleanUrl = charPos !== -1 ? this._router.url.slice(0, charPos) : this._router.url;
        return (cleanUrl === url);
    }

    getClearanceItem(id: string): void {
        this.showSpinner = true;
        this._clearanceItemService.getCI(id)
            .subscribe
            (
                (data) => {
                    this.ngZone.run(() => {
                        this.onCIRetrieved(data);
                        this.selectedItemId = null;
                        this.showSpinner = false;
                        this.cd.detectChanges();
                    });
                },
            );
    }

    onCIRetrieved(data: ClearanceItem) {
        let item = this.itemList.findIndex(i => i.id == data.id);
        // this.processUITags(data);
        this.checkDefaultImage(data);
        if (item < 0)
            this.itemList.push(data);
        else
            this.itemList[item] = data;

    }

    get IsSearchMessageDefault(): Boolean {
        return this.searchMessage === this.defaultMessage;
    }

    /** STG shows the red error icon for empty results and HTTP errors, not the default prompt. */
    get showNoResultsIcon(): boolean {
        return this.inErrorState || this.searchMessage === this.noRecordsFoundMessage;
    }

    clearField(e: string) {
        let field = this.searchForm.get(e);
        if (field) {
            if (e === 'status') {
                this.setMultiselectFilterToAll(this.statusMultiSelect);
            } else if (e === 'tags') {
                this.setMultiselectFilterToAll(this.tagsMultiSelect);
            } else {
                field.setValue('');
            }
            this.searchMessage = this.defaultMessage;
        }
    }

    statusChanged(value) {
        console.log(this.searchForm.get('status').value);
    }

    loadCILookups(): void {
        let projectId = null;
        
        if (this.searchForm)
            projectId =   this.searchForm.controls.currentProject.value ? this.searchForm.get('projectId').value : null;

        this._appService.retrieveCILookups('CIStatus,Tags', projectId, true)
            .subscribe(
                (list) => {
                    if (list) {
                        this.onLookupsRetrieved(list);
                    }
                },
                (error) => {
                    this._errorHandler.processError(error);
                }
            );

    }
    onLookupsRetrieved(list: LookupList[]): void {
        if (list && list.length > 0) {
            
            if (list.find(it => it.lookupType == 'CIStatus') != null && list.find(it => it.lookupType == 'CIStatus').lookupData) {
                this.statusLookup = [];
                this.statusLookupBulk = [];
                list.find(it => it.lookupType == 'CIStatus').lookupData.forEach(look => { this.statusLookup.push(look); this.statusLookupBulk.push(look) });
                
                let staticLookup = new ILookup('All', 'All');
                this.statusLookup.splice(0, 0, staticLookup);

                if(!this._authService.secondApproval){
                    staticLookup = new ILookup('Urgent', 'Urgent');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                    staticLookup = new ILookup('All Pending', 'All Pending');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                    staticLookup = new ILookup('All Clear', 'All Clear');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                }
            }

            if (list.find(it => it.lookupType == 'Tags') != null && list.find(it => it.lookupType == 'Tags').lookupData) {
                this.tagsLookup = [];
                list.find(it => it.lookupType == 'Tags').lookupData.forEach(look => { if (look.type=='Static' || true) { this.tagsLookup.push(look); }});
                let manualLookup = new ILookup('All', 'All');
                this.tagsLookup.splice(0, 0, manualLookup);
                
            }
        }

    }
    hideTotalRows(): Boolean {
        return this.listSearchData && !this.listSearchData.totalNumberOfRecords;
    }

    canExecuteSearch(): boolean {
        return ((this.searchForm.get('keyword').value && this.searchForm.get('keyword').value.length >= 2)
            || (this.searchForm.get('projectName').value)
            || (this.searchForm.get('status').value && this.searchForm.get('status').value != 'All')
            || (this.searchForm.get('tags').value)
            || (this.searchForm.get('copyright').value)
            || (this.searchForm.get('author').value)
            || (this.searchForm.get('episode').value)
            || (this.searchForm.get('season').value)
            || (this.searchForm.get('reportGroup').value)
            || (this.searchForm.get('deadline').value)
            || (this.searchForm.get('createdDate').value)
        );
    }

    sortOrderTooltip = 'sort desc';
    sortOrderIcon = 'arrow_downward';

    filterChanged(filterType: string) {

        this.currentPage = 1;
        this.totalItems = 0;

        if (filterType === 'sortOrder') {
            if (!this.listSearchData.sortOrder || this.listSearchData.sortOrder == 'DESC') {
                this.searchForm.controls.sortOrder.setValue('ASC', { emitEvent: false });
                this.sortOrderIcon = 'arrow_upward';
                this.sortOrderTooltip = 'sort desc';
                this.listSearchData.sortOrder = 'ASC'
            }
            else {
                this.searchForm.controls.sortOrder.setValue('DESC', { emitEvent: false });
                this.sortOrderIcon = 'arrow_downward';
                this.sortOrderTooltip = 'sort asc';
                this.listSearchData.sortOrder = 'DESC'
            }
        }

        this.searchForm.markAsDirty();

        if (this.itemList.length > 0) {
            this.searchItems();
        }

        return false;
    }

    /** Close open filter selects so the CDK backdrop does not trap Apply/Clear (TA-005). */
    closeOpenFilterSelects(): void {
        if (!this.filterSelects) {
            return;
        }
        this.filterSelects.forEach(select => {
            if (select && select.panelOpen) {
                select.close();
            }
        });
    }

    searchItems(): void {
        this.closeOpenFilterSelects();

        if (this.canExecuteSearch()) {
            
            // Copy the form values over the product object values
            this.showSpinner = true;
            this.searchForm.get('keyword').setValue(DateUtils.tryToFormatStringToDateFormat(this.searchForm.get('keyword').value, 'yyyy-MM-dd'));
            DateUtils.normalizeMaterialDateControls(this.searchForm, ['deadline', 'createdDate']);
            this.listSearchData = <AdvancedSearchData>Object.assign({}, this.listSearchData, this.searchForm.value);

            if (this.listSearchData.status.indexOf('All')!=-1) {
                this.listSearchData.status = [];
            }

            if (this.listSearchData.tags.indexOf('All')!=-1) {
                this.listSearchData.tags = [];
            }

            this.listSearchData.pageSize = this.pageSize;
            this.listSearchData.pageStartIndex = 0;
            this.listSearchData.createdDate = DateUtils.toApiDate(this.listSearchData.createdDate);
            this.listSearchData.deadline = DateUtils.toApiDate(this.listSearchData.deadline);

            this.inErrorState = false;
            this.isLoadingRecord = true;
            this.listSearchData.resultSet = []
            this.searchMessage = '';

            this._searchService.search(this.listSearchData)
                .subscribe
                (
                    (data) => {
                        this.ngZone.run(() => {
                            this.showSpinner = false;
                            setTimeout(() => {
                                this.closeFirst();
                            }, 1500);
                            this.searchForm.markAsPristine();
                            if (!data.resultSet || data.resultSet.length == 0) {
                                this.searchMessage = this.noRecordsFoundMessage;
                                this.itemList = [];
                                this.selectedItemId = null;
                            }
                            this.totalItems = data.totalNumberOfRecords;
                            this.currentPage = 1;
                            this.itemSelectedList = [];
                            this.onListDataRetrieved(data);
                            this.cd.detectChanges();
                        });
                    }
                    ,
                    (error: any) => {
                        this.ngZone.run(() => {
                            setTimeout(() => {
                                this.closeFirst();
                            }, 1500);                    // console.error('SearchComponent >> err:' + error);
                            this.itemList = [];
                            this.selectedItemId = null;
                            this.showSpinner = false;
                            this.isLoadingRecord = false
                            if (error.status == 404) {
                                this.searchMessage = this.noRecordsFoundMessage;
                            } else {
                                this.searchMessage = 'Unexpected error';
                                this._errorHandler.processError(error);
                            }
                            this.inErrorState = true;
                            this.cd.detectChanges();
                        });
                    }
                );
            localStorage.setItem('AdvancedSearchData', JSON.stringify(this.listSearchData));

        } else {
            //this should not be <-- well it happens when user hits Enter...
            console.error('Form is not dirty, can\'t initiate search...');
        }

    }

    onListDataRetrieved(listSearchData: AdvancedSearchData, resetList: Boolean = true): void {
        // console.log(listSearchData + ', resetList:' + resetList);
        if (resetList) {
            this.itemList = [];
            this.selectedItemId = null;
        }

        if (listSearchData.resultSet) {
            listSearchData.resultSet.forEach(item => this.itemList.push(this.checkDefaultImage(item)));
            this.listSearchData.totalNumberOfRecords = listSearchData.totalNumberOfRecords;
            this.listSearchData.pageStartIndex = listSearchData.pageStartIndex;
            this.listSearchData.resultSet = listSearchData.resultSet;
        }
        this.isLoadingRecord = false
    }

    checkDefaultImage(item: ClearanceItem): ClearanceItem {
        if (item) {
            
            if (item.images && item.images.length > 0) {
                //determine default image
                let imagesOnly = item.images.filter(i => i.assetType.toLowerCase() === 'image')
                item.defaultImage = imagesOnly.find(i => i.defaultC == true);
                if (!item.defaultImage && imagesOnly.length > 0)
                    item.defaultImage = imagesOnly[0];
            }
            else {
                //add default image
                item.images = [];
                let image = new CIImage();
                // image.fullUrl='https://s3.amazonaws.com/uifaces/faces/twitter/brad_frost/128.jpg';
                item.images.push(image);
            }
        }
        return item;
    }

    private selectedItemId: string = null;
    openItemDetails(itemId: string, projectId: string, projectName: string): void {
        if (projectId != this.openedProject.ProjectId) {
            this._messageBrokerService.setCurrentProject(new ProjectItem(projectId, projectName), true);
        }
        this.selectedItemId = itemId;
        this._router.navigateByUrl('/projects/' + projectId + '/items/' + itemId);
    }

    subScribeProjectNameChanges(): void {
        this._messageBrokerService.getCurrentProject().subscribe((project: ProjectItem) => {
            if (project != null) {
                // this.currentProjectName = project.ProjectName;
                this.openedProject = project;
                if (project.ProjectId) {
                    this.searchForm.get('projectId').setValue(project.ProjectId);
                } else {
                    console.error('projectId: ' + project.ProjectId);
                }
                this.loadCILookups();
            }
        });
    }

    loadRecords = (pageSize, currentPage) =>{
        this.pageSize = pageSize;
        this.currentPage = currentPage;
        let nextPageRecordStartIndex = pageSize * (currentPage -1);

        //if there are more records to fetch
        if (this.listSearchData.resultSet.length > 0 && this.listSearchData.totalNumberOfRecords > nextPageRecordStartIndex && nextPageRecordStartIndex < 2000) {
            this.listSearchData.resultSet = [];
            this.showSpinner = true;
            this.inErrorState = false;
            this.listSearchData.pageStartIndex = nextPageRecordStartIndex;
            this.listSearchData.pageSize = pageSize;

            this.listSearchData.createdDate = DateUtils.toApiDate(this.listSearchData.createdDate);
            this.listSearchData.deadline = DateUtils.toApiDate(this.listSearchData.deadline);

            this._searchService.search(this.listSearchData)
                .subscribe
                (
                    (data) => {
                        this.ngZone.run(() => {
                            this.showSpinner = false;
                            this.totalItems = data.totalNumberOfRecords;
                            this.onListDataRetrieved(data, true);
                            this.loadPageSelection();
                            this.cd.detectChanges();
                        });
                    },
                    (error: any) => {
                        this.ngZone.run(() => {
                            this.showSpinner = false;
                            if (error.status != 404) {
                                this._errorHandler.processError(error);
                            }
                            this.inErrorState = true;
                            this.cd.detectChanges();
                        });
                    }
                );
        }

    }

    loadPageSelection(){
        if(this.itemSelectedList.length === 0) return;

        var selectedItems = this.itemSelectedList;
        this.itemList.forEach(function (item) {
            var selected = selectedItems.filter(it => it.id === item.id);
            if(selected.length > 0){
                item.isSelected = true;
            }
        });
    }

    updateItemSelected(item: ClearanceItem, isSelected: boolean): void {
        if (isSelected) {
            if (!this.itemSelectedList.some(i => i.id == item.id)) {
                this.itemSelectedList.push(item);
            }
        } else {
            const index = this.itemSelectedList.findIndex(i => i.id == item.id);
            if (index > -1) {
                this.itemSelectedList.splice(index, 1);
            }
        }
    }

    clearItemSelection(): void {
        this.itemSelectedList.forEach(i => i.isSelected = false);
        this.itemSelectedList = [];
    }

    updateSelection(){
        var selectedItems = this.itemSelectedList;
        this.itemList.forEach(function (item) {
            if(item.isSelected){
                if (selectedItems.findIndex(i => i.id==item.id) === -1) {
                    selectedItems.push(item);
                }
            }else{
                const index = selectedItems.findIndex(i => i.id==item.id);
                if (index > -1) {
                    selectedItems.splice(index, 1);
                }
            }
          }); 
    }

    showFilters(e): void {
        this.showMobileFilters = true;
        if (e) {
            e.stopPropagation();
        }
    }

    close(e) {
        const keptPageSize = this.pageSize === 50 ? 50 : 20;

        // Reset filters to defaults; keep page size (not a search filter).
        this.searchForm.reset({
            keyword: '',
            currentProject: true,
            projectId: '',
            sortBy: this.sortByLookup[0].id,
            sortOrder: 'DESC',
            status: ['All'],
            projectName: '',
            tags: ['All'],
            copyright: '',
            author: '',
            episode: '',
            season: '',
            reportGroup: '',
            deadline: null,
            createdDate: null,
            pageSize: keptPageSize,
            pageStartIndex: 0,
            totalNumberOfRecords: 0
        });
        this.setMultiselectFilterToAll(this.statusMultiSelect);
        this.setMultiselectFilterToAll(this.tagsMultiSelect);
        //cleanup local store.
        localStorage.removeItem('AdvancedSearchData');
        if (!this.openedProject || !this.openedProject.ProjectId) {
            console.error('Could not detect a current project Id!');
        } else {
            this.searchForm.get('projectId').setValue(this.openedProject.ProjectId);
        }

        this.itemList = [];
        this.itemSelectedList = [];
        this.selectedItemId = null;
        this.searchMessage = this.defaultMessage;
        if (this.listSearchData) {
            this.listSearchData.totalNumberOfRecords = 0;
        }
        return false;
    }
    imageLoadFinished(img) {
        // Preserva hook de imagen sin jQuery.
    }

    stopPropagation(e): void {
        e.stopPropagation();
    }

    selectAllItems(e): void {
        const checked = e && e.checked !== undefined ? e.checked : (e.target && e.target.checked);
        if (this.itemList) {
            if (checked) {
                this.itemList.forEach(it => it.isSelected = true);
            }
            else {
                this.itemList.forEach(it => it.isSelected = false);
            }
            this.updateSelection();
        }
    }

    get allItemsSelected(): boolean {
        let ret = this.itemList.filter(i => i.isSelected === true).length === this.itemList.length;
        // console.log('ret: ' + ret);
        return ret;
    }

    onModalInitRequest(modalId: string) {
        if (modalId === 'modal-status') {
            this.initializeStatusModal();
        } else if (modalId === 'modal-groupName') {
            this.initializeGroupNameModal();
        } else if (modalId === 'modal-tag') {
            this.initializeTagModal();
        } else if (modalId === 'modal-release') {
            this.initializeDocModal();
        } else if (modalId === 'modal-image') {
            this.initializeImageModal();
        } else {
            console.error('Did not understand the modal Id request:' + modalId);
        }
    }

    initializeStatusModal(): void {
        if (this.itemSelectedList && this.itemSelectedList.length > 0) {
            this.bulkDataList = this.statusLookupBulk;
            this.currentBulkModalId = 'modal-status';
            this.bulkActionComponent.setForm(this.initStatusForm());
            this.bulkActionComponent.initializeModal('modal-status', this.changeStatus.bind(this));
        }
    }

    initStatusForm(): FormGroup {
         let f = this.fb.group(
            {
                status: this._authService.secondApproval ? 'APPROVAL PENDING' : 'NEW',
                comments: ''
            });

        this.bulkActionComponent.showComments = this.statusRequiresComments(f.controls.status.value);

        f.controls.status.valueChanges.subscribe(v => {
            this.bulkActionComponent.showComments = this.statusRequiresComments(v);
           if (this.bulkActionComponent.showComments) {
                if (!this._authService.secondApproval) {
                    f.controls.comments.setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(255)]);
                }
            } else {
                f.controls.comments.clearValidators();
            }
            f.controls.comments.updateValueAndValidity();
        });

        return f;
    }
    statusRequiresComments(status: string): boolean {
        return status === 'DENIED' || status === 'DEFERRED' || status === 'PENDING - Production Info Required' || status === 'PENDING - Modifications Required';
    }
    

    currentBulkModalId = '';
    initializeGroupNameModal(): void {
        if (this.itemSelectedList && this.itemSelectedList.length > 0) {
            this.currentBulkModalId = 'modal-groupName';
            this.bulkActionComponent.initializeModal('modal-groupName', this.updateGroupName.bind(this));
        }
    }

    initializeTagModal(): void {
        if (this.itemSelectedList && this.itemSelectedList.length > 0) {
            this.bulkDataList = [];
            this.currentBulkModalId = 'modal-tag';
            this.bulkActionComponent.initializeModal('modal-tag', this.addTags.bind(this));
        }

    }

    initializeImageModal(): void {
        if (this.itemSelectedList && this.itemSelectedList.length > 0) {
            this.bulkDataList = [];
            this.currentBulkModalId = 'modal-image';
            this.bulkActionComponent.initializeModal('modal-image', this.addImages.bind(this));
        }

    }

    initializeDocModal(): void {
        if (this.itemSelectedList && this.itemSelectedList.length > 0) {
            this.bulkDataList = [];
            this.currentBulkModalId = 'modal-release';
            this.bulkActionComponent.initializeModal('modal-release', this.addDocuments.bind(this));
        }

    }


    addTags(selectedTags: CITag[]): void {

        if (selectedTags && selectedTags.length > 0 && this.itemSelectedList && this.itemSelectedList.length > 0) {

            this.massUpdateData.updateType = 'AddTags';
            this.massUpdateData.tags = [];

            this.massUpdateData.tags = selectedTags;
            this.massUpdateData.clearanceItems = [];
            this.itemSelectedList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._searchService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this.bulkActionComponent.closeModal();
                            this._notificationsService.add(new Notification('success', 'Selected Items are updated with tags '));
                            this.searchItems();
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }

    addImages(selectedImages: CIAsset[]): void {

        if (selectedImages && selectedImages.length > 0 && this.itemSelectedList && this.itemSelectedList.length > 0) {

            this.massUpdateData.updateType = 'AddImages';
            this.massUpdateData.images = [];
            this.massUpdateData.documents = [];

            selectedImages.forEach(it => {
                it.fullUrl = '';
                it.defaultC = false;
                it.assetType = 'Image';
            });
            this.massUpdateData.images = selectedImages;
            this.massUpdateData.clearanceItems = [];
            this.massUpdateData.projectId = 'Generic';//this.listSearchData.projectId;
            this.itemSelectedList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._searchService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this.bulkActionComponent.closeModal();
                            this._notificationsService.add(new Notification('success', 'Selected images are added to selected items '));
                            this.searchItems();
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }
    addDocuments(selectedDocs: CIAsset[]): void {

        if (selectedDocs && selectedDocs.length > 0 && this.itemSelectedList && this.itemSelectedList.length > 0) {

            this.massUpdateData.updateType = 'AddDocuments';
            this.massUpdateData.images = [];
            this.massUpdateData.documents = <CIDocument[]>selectedDocs;
            this.massUpdateData.clearanceItems = [];
            this.massUpdateData.projectId = 'Generic';//this.listSearchData.projectId;
            this.itemSelectedList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._searchService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this.bulkActionComponent.closeModal();
                            this._notificationsService.add(new Notification('success', 'Selected documents are added to selected items '));
                            this.searchItems();
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }

    changeStatus(status: FormGroup) {

        console.log(this.massUpdateData);
        if (this.massUpdateData.status != 'All' && this.itemSelectedList && this.itemSelectedList.filter(it => it.isSelected).length > 0) {

            this.massUpdateData.updateType = 'ChangeStatus';
            this.massUpdateData.statusChangeComments = status.value.comments;
            this.massUpdateData.status = status.value.status;

            this.massUpdateData.clearanceItems = [];
            this.itemSelectedList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._searchService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this._notificationsService.add(new Notification('success', 'Selected Items are updated with status ' + this.massUpdateData.status));
                            this.searchItems();
                            this._messageBrokerService.sendMessageToRefreshLeftNav('');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }

    updateGroupName(groupName: FormGroup): void {

        if (this.itemSelectedList && this.itemSelectedList.length > 0) {

            this.massUpdateData.updateType = 'GroupName';
            this.massUpdateData.groupName = groupName.value.reportGroupName;

            this.massUpdateData.clearanceItems = [];
            this.itemSelectedList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._searchService.massUpdateItems(this.massUpdateData)
                .subscribe(
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this._notificationsService.add(new Notification('success', 'Selected Items were updated with Group Name \'' + this.massUpdateData.groupName + '\''));
                            this.searchItems()
                            this._messageBrokerService.sendMessageToRefreshLeftNav('');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        // this._errorHandler.processError(error);
                    }
                );
        }
    }


    get anyItemSelected(): boolean {
        return !!(this.itemSelectedList && this.itemSelectedList.some(it => it.isSelected));
    }

    stringTitle(item: ClearanceItem): string {
        return item.titles.filter(t => !!!t.isDefault && item.name != t.name) .map(t => t.name).join(', ');
    }

    moreTitlesVisible(item: ClearanceItem){
        if (item.titles && item.titles.length>0){
            return item.titles.filter(t => !!!t.isDefault && item.name != t.name).length > 0
        }
    }

    showMoreTitles(item: ClearanceItem): void {
        this.selectedItem = item;
        this.showOtherTitlesModal = true;
    }

    closeMoreTitlesModal(event?: Event): void {
        if (event) {
            event.stopPropagation();
        }
        this.showOtherTitlesModal = false;
    }

    get isMobileAndDirty() {
        return this.searchForm.dirty && SharedUtils.IsMobile();
    }

    get projectIdFromSelectedItems() {

        // return [...new Set(this.itemList.map(obj => obj.projectId)) ];
        let uniques = Array.from(new Set(this.itemList.filter(it => it.isSelected).map(obj => obj.projectId)));
        // console.log('projectIdFromItemList: ' + JSON.stringify(uniques));

        return uniques.length == 1 ? uniques[0] : null;

    }

    statusFilterChanged(selectedOptions: string[]){
        const next = (selectedOptions || []).slice();
        const prev = this.lastStatusSelectionForFilter.slice();
        let normalized = this.applyAllExclusiveMultiSelection(prev, next, 'All');
        if (normalized.length === 0) {
            normalized = ['All'];
        }
        this.statusMultiSelect.allOptionChecked = normalized.length === 1 && normalized[0] === 'All';
        this.searchForm.get('status').setValue(normalized, { emitEvent: false });
        this.lastStatusSelectionForFilter = normalized.slice();
    }

    /**
     * Misma regla que el multiselect Materialize legacy: All excluye al resto y viceversa.
     */
    private applyAllExclusiveMultiSelection(prev: string[], next: string[], allToken: string): string[] {
        const hasAll = next.indexOf(allToken) !== -1;
        const nonAll = next.filter(v => v !== allToken);
        if (hasAll && nonAll.length > 0) {
            const prevHasAll = prev.indexOf(allToken) !== -1;
            return prevHasAll ? nonAll : [allToken];
        }
        if (hasAll) {
            return [allToken];
        }
        return nonAll;
    }

    private syncStatusFilterSnapshotFromForm(): void {
        const st = this.searchForm.get('status').value;
        const arr = Array.isArray(st) ? st.slice() : ['All'];
        this.lastStatusSelectionForFilter = arr.length ? arr : ['All'];
        this.statusMultiSelect.allOptionChecked =
            this.lastStatusSelectionForFilter.length === 1 && this.lastStatusSelectionForFilter[0] === 'All';
    }

    tagsFilterChanged(selectedOptions: string[]){
        const next = (selectedOptions || []).slice();
        const prev = this.lastTagsSelectionForFilter.slice();
        let normalized = this.applyAllExclusiveMultiSelection(prev, next, 'All');
        if (normalized.length === 0) {
            normalized = ['All'];
        }
        this.tagsMultiSelect.allOptionChecked = normalized.length === 1 && normalized[0] === 'All';
        this.searchForm.get('tags').setValue(normalized, { emitEvent: false });
        this.lastTagsSelectionForFilter = normalized.slice();
    }

    private syncMultiselectSnapshotsFromForm(): void {
        this.syncStatusFilterSnapshotFromForm();
        this.syncTagsFilterSnapshotFromForm();
    }

    private syncTagsFilterSnapshotFromForm(): void {
        const t = this.searchForm.get('tags').value;
        const arr = Array.isArray(t) ? t.slice() : ['All'];
        this.lastTagsSelectionForFilter = arr.length ? arr : ['All'];
        this.tagsMultiSelect.allOptionChecked =
            this.lastTagsSelectionForFilter.length === 1 && this.lastTagsSelectionForFilter[0] === 'All';
    }

    setMultiselectFilterToAll(multiSelect){
        multiSelect.formControl.setValue(['All']);
        multiSelect.allOptionChecked = true;
        if (multiSelect === this.statusMultiSelect) {
            this.lastStatusSelectionForFilter = ['All'];
        } else if (multiSelect === this.tagsMultiSelect) {
            this.lastTagsSelectionForFilter = ['All'];
        }
    }

    enqueReport(): void {
        this._reportService.generateReports(this.reportGenerateParams)
            .subscribe(
                (res) => {
                    console.log('queued: ' + res);
                    this._notificationsService.add(new Notification('success', 'Your report has been submitted for processing, please check the Reports page.'));
                    this.showSpinner = false;
                },
                (error: any) => {
                    var e = JSON.stringify(error);
                    if(e.indexOf("AntiXssMiddleware") !== -1 || error.includes("AntiXssMiddleware")){
                        this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));                     
                    }else{
                        this._errorHandler.processError(error);
                    }
                }
            );
    }

    generateReport() {
        if (!this.searchForm.dirty){
            let searchValues = [];
            searchValues.push(['Keyword: ', this.listSearchData.keyword]);
            if (!this.searchForm.controls.currentProject.value){
                if (this.listSearchData.projectName && this.listSearchData.projectName.length>0)
                    searchValues.push(['', 'Project name contains: ' + this.listSearchData.projectName]);
                else
                    searchValues.push(['', 'All projects']);
            }
            searchValues.push(['Tags: ', this.listSearchData.tags.join(', ')]);
            searchValues.push(['Copyright: ', this.listSearchData.copyright]);
            searchValues.push(['Author: ', this.listSearchData.author]);
            searchValues.push(['Report Group: ', this.listSearchData.reportGroup]);
            searchValues.push(['Report Group: ', this.listSearchData.reportGroup]);
            searchValues.push(['Season: ', this.listSearchData.season]);
            searchValues.push(['Episode: ', this.listSearchData.episode]);
            searchValues.push(['Deadline: ', this.listSearchData.deadline]);
            searchValues.push(['Submission Date: ', this.listSearchData.createdDate]);
    
            let searchValue = searchValues.filter(searchValue => {
                if (searchValue[1] && searchValue[1].length>0)
                    return searchValue;
            }).map(searchValue => searchValue[0] + searchValue[1]).join('; ') ;
    
            this.reportGenerateParams = new ReportBuilder();
            this.reportGenerateParams.searchBy = '';
            this.reportGenerateParams.searchByValue = searchValue || '';
            this.reportGenerateParams.projectId = this.listSearchData.projectId;
            this.reportGenerateParams.sortedBy = this.listSearchData.sortBy;
            this.reportGenerateParams.sortDirection = this.listSearchData.sortOrder;
            this.reportGenerateParams.reportName = 'cilistreport';
            this.reportGenerateParams.reports = [];
            this.reportGenerateParams.fromAdvancedSearch = true;
    
            if (this.listSearchData.status && this.listSearchData.status.length>0) {
                this.reportGenerateParams.status = this.listSearchData.status.join(', ');
            }
            else {
                this.reportGenerateParams.status = 'All';
            }
            if (this.anyItemSelected){
                this.reportGenerateParams.selectedIDs = this.getSelectedCIIds();
                this.enqueReport();
            }
            else{
                this.getAllItemsForExportOption();
            }
        }
        else{
            this._notificationsService.add(new Notification('warn','','Search params have changed. Press APPLY button before EXPORT LIST',false))
        }
        
    }


    getSelectedCIIds(): string{
        return "##" + this.itemSelectedList.filter(it => it.isSelected).map(item => item.id).join("##") + "##";
    }

    getAllItemsForExportOption(){
        if (this.canExecuteSearch()) {
            this.showSpinner = true;

            const listSearchEntireDataset : AdvancedSearchData = {...this.listSearchData};
            listSearchEntireDataset.resultSet = [];
            listSearchEntireDataset.getEntireDataset = true;
            
            this._searchService.search(listSearchEntireDataset)
                .subscribe
                (
                    (data) => {
                        if (data.resultSet || data.resultSet.length != 0) {
                            this.reportGenerateParams.selectedIDs =  "##" + data.resultSet.map(ci => ci.id).join("##") + "##";
                            this.enqueReport();
                        }
                    }
                    ,
                    (error: any) => {
                        this.searchMessage = 'Unexpected error';
                        this._errorHandler.processError(error);
                    }
                );

        } else {
            console.error('Form is not dirty, can\'t initiate search...');
        }
    }

    downloadImages(){
        const fileName = 'Clearance Images ' + DateUtils.toStringFromDateTime(new Date()) + '.zip';
        this._appService.enqueueDownload(fileName);
        this._searchService.downloadImages(this.getSelectedCIIds()).subscribe( response => {
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(response);
            downloadLink.download = fileName;
            downloadLink.click();
            this._notificationsService.add(new Notification('success', 'Download ' + fileName + ' complete.'));
            this._appService.removeFromDownloadQueue(fileName);
        }, error => {
            this._errorHandler.processError(error);
        });
    }

    onPageSizeChange(){
        this.currentPage = 1;
        this.loadRecords(this.searchForm.get('pageSize').value, this.currentPage);
    }

    getPaginationText(): string{
        const pageFrom: Number = (this.currentPage-1)*this.pageSize+1;
        const pageTo: Number = this.currentPage*this.pageSize > this.totalItems ? this.totalItems : this.currentPage*this.pageSize;
        return "Showing " + pageFrom + " to " + pageTo + " items of " + this.totalItems;
    }

    totalRowsLabel(): string {
        return this.totalItems === 1 ? '1 item found' : this.totalItems + ' items found';
    }

    getSelectText(): string{
        const pageFrom: Number = (this.currentPage-1)*this.pageSize+1;
        const pageTo: Number = this.currentPage*this.pageSize > this.totalItems ? this.totalItems : this.currentPage*this.pageSize;
        return "Select items " + pageFrom + " to " + pageTo;
    }
}